@if (fileJob(); as file) {
  @let id = jobId();
  @let mode = viewMode();
  @let isCompactMode = compact();

  <div class="file-item" [ngClass]="isCompactMode ? 'compact' : 'default'" [dataSelector]="dataSelector + '-container-' + id">
    <div class="file-columns" [ngClass]="isCompactMode ? 'compact' : 'default'">
      <div class="left-content" [ngClass]="[mode]" [dataSelector]="dataSelector + '-left-content-' + id">
        @switch (mode) {
          @case ('waiting') {
            <awn-file-item-icon
              [fileName]="file.fileName"
              iconName="clock"
              [cssClasses]="[mode]"
              [dataSelector]="dataSelector + '-waiting-icon-' + id"
            />
          }
          @case ('uploading') {
            <awn-file-item-icon
              [fileName]="file.fileName"
              iconName="refresh-ccw"
              [cssClasses]="[mode]"
              [dataSelector]="dataSelector + '-uploading-icon-' + id"
            />
          }
          @case ('linking') {
            <awn-file-item-icon
              [fileName]="file.fileName"
              iconName="refresh-ccw"
              [cssClasses]="[mode]"
              [dataSelector]="dataSelector + '-linking-icon-' + id"
            />
          }
          @case ('error') {
            <awn-file-item-icon
              [fileName]="file.fileName"
              iconName="alert-circle"
              [cssClasses]="[mode]"
              [dataSelector]="dataSelector + '-error-icon-' + id"
            />
          }
          @default {
            <awn-file-item-icon [fileName]="file.fileName" [cssClasses]="[mode]" [dataSelector]="dataSelector + '-default-icon-' + id" />
          }
        }
      </div>

      <div class="center-content" [ngClass]="isCompactMode ? 'compact' : 'default'" [dataSelector]="dataSelector + '-center-content-' + id">
        <span class="file-name" tooltipOverflow [dataSelector]="dataSelector + '-file-name-' + id">
          {{ file.fileName }}
        </span>

        @switch (mode) {
          @case ('waiting') {
            <span class="file-status" [dataSelector]="dataSelector + '-status-waiting-' + id"> Waiting... </span>
          }
          @case ('uploading') {
            <div
              class="upload-progress"
              [ngClass]="isCompactMode ? 'compact' : 'default'"
              [dataSelector]="dataSelector + '-status-uploading-' + id"
            >
              <span>{{ file | fileUploadedProgress }}</span>
              @if (isCompactMode) {
                <span> • {{ file.progress | number: '1.0-0' }}%</span>
              }
            </div>
            @if (isCompactMode) {
              <mat-progress-bar class="upload-progress-bar" [value]="file.progress"></mat-progress-bar>
            }
          }
          @case ('categorizing') {
            <div class="sub-content categorizing">
              <aiwyn-icon
                namespace="phosphor"
                name="sparkle"
                class="categorizing-icon"
                [height]="16"
                [width]="16"
                [dataSelector]="dataSelector + '-status-categorizing-' + id"
              />
              <span class="body-300 fst-italic color-gold-200 file-status" [dataSelector]="dataSelector + '-staged-file-status-' + id">
                Categorizing...
              </span>
            </div>
          }
          @case ('error') {
            <div class="sub-content">
              <span class="error" [dataSelector]="dataSelector + '-status-error-' + id">
                {{ file.error?.message }}
              </span>
            </div>

            <span class="retry" (click)="retryFileUpload(file.jobId)"> Retry </span>
          }
          @case ('categorization-timeout') {
            <div class="sub-content">
              <aiwyn-icon name="alert-triangle" [height]="12" [width]="12" [dataSelector]="dataSelector + '-timeout-icon-' + id" />
              <span class="categorization-timeout" [dataSelector]="dataSelector + '-status-timeout-' + id"> Categorization timed out </span>
            </div>
          }
          @case ('linking') {
            <span class="linking" [dataSelector]="dataSelector + '-status-linking-' + id"> Uploading... </span>
          }
          @case ('uploaded') {
            <span class="uploaded" [dataSelector]="dataSelector + '-status-uploaded-' + id">
              {{ file.bytesTotal | fileSize: 1 }}
            </span>
          }
        }
      </div>

      <div class="right-content" [dataSelector]="dataSelector + '-right-content-' + id">
        @if (canDelete()) {
          <button
            andButton
            color="ghost"
            size="small"
            (click)="cancelUploadJob(file.jobId)"
            [dataSelector]="dataSelector + '-right-content-button-' + id"
          >
            <aiwyn-icon name="x" [height]="16" [width]="16"></aiwyn-icon>
          </button>
        }
      </div>
    </div>

    @if (!isCompactMode && mode === 'uploading') {
      <div class="bottom-upload-progress" [dataSelector]="dataSelector + '-bottom-upload-progress-' + id">
        <mat-progress-bar class="upload-progress-bar mt-3" [value]="file.progress"></mat-progress-bar>
        <span class="progress" [ngClass]="{ 'me-2': file.progress === 100 }"> {{ file.progress }}% </span>
      </div>
    }
  </div>
}
